export default __webpack_public_path__ + "static/media/15-Landbobanken.adee5f95.png";